// @ts-nocheck
import React from "react";
import Buttons from "../../../../../../base/basicComponents/button";
import EllipsisToolTip from "../../../../../../base/basicComponents/ellipsisToolTip";
import HistoricalVersionComponent from "../../../../../../base/basicComponents/historicalVersionComponent";
import { FileStatusDiv, ProposedChangeTagDiv } from "../../../../../../base/basicComponents/status";
import UploadFile from "../../../../../../base/basicComponents/uploadFile";
import BaseTbody from "../../../../../commonComponents/fileTbodys/baseFileTbody";
import { fileTags, flowBusinessIdMap } from "../../../../../publicDictionaryValues";
import { PreviewFileLink } from "app/pages/previewFile";
import "../index.scss";

export default class UpdateSupportingFileTbody extends BaseTbody {
  /**
   * function about show link if column type is link
   * @param {*} rowColumn
   * @param {*} column
   * @returns
   */
  returnFileName = (rowColumn: any, column: any, row: any) => {
    const fileId = row.data.find((item: any) => item.name === "fileId").value;
    const fileKey = row.data.find((item: any) => item.name === "fileKey").value.trim();

    return (
      <div className="fileNameContainer">
        <EllipsisToolTip
          children={
            <PreviewFileLink fileId={fileId} fileName={rowColumn.value}>
              {rowColumn.value}
            </PreviewFileLink>
          }
          title={rowColumn.value}
          placement="top"
        />
        {/* @ts-ignore */}
        {this.props.isShowHistoryVersion && (
          <HistoricalVersionComponent
            fileId={fileId}
            fileKey={fileKey}
            flowBusinessId={flowBusinessIdMap.supportingFile}
          />
        )}
        {rowColumn.tagValue !== null && <FileStatusDiv status={rowColumn.tagValue} />}
      </div>
    );
  };

  returnTag = (rowColumn: any) => {
    return <ProposedChangeTagDiv status={rowColumn.value} />;
  };

  returnButton = (row: any, column: any, rowIndex: any, isSupportingFile: any) => {
    const fileNameData = row.data.find((item: any) => item.name === "fileName");
    const tagValue = fileNameData && fileNameData.tagValue;

    return (
      <div className="buttonTd-content">
        {tagValue !== fileTags.new && (
          <>
            <Buttons
              color={column.approveColor}
              size="small"
              onClick={(e: any) => column.onApproveClick(e)}
              disabled={row.isApproveDisabled}
              rowindex={rowIndex}
              testid={`update-supporting-file-approve-btn-${rowIndex}`}
            >
              {column.approveText}
            </Buttons>
            <UploadFile
              fileInputRef={row.replaceRef}
              isMultiple={false}
              handleFileSelect={this.props.handleFileSelect}
              rowindex={rowIndex}
              isSupportingFile={isSupportingFile}
            />
          </>
        )}
        <Buttons
          color={column.returnColor}
          size="small"
          onClick={column.onReturnClick(rowIndex)}
          disabled={row.isReturnDisabled || tagValue === fileTags.deleted}
          rowindex={rowIndex}
          testid={`update-supporting-file-return-btn-${rowIndex}`}
        >
          {column.returnText}
        </Buttons>
      </div>
    );
  };

  render() {
    const {
      data,
      columns,
      procedureNoteMaxLength,
      fileSectionDisabled,
      optionList,
      isShowReturnReason,
      currentRole,
    } = this.props;

    const typeToClassName = {
      link: "linkTd",
      input: "inputTd",
      default: "textTd",
      tag: "tagTd",
      select: "selectTd",
      button: "buttonTd",
      fileName: "fileNameTd",
    };

    return (
      <>
        <tbody className="update-tbody">
          {data.map((row: any, rowIndex: any) => {
            return (
              <tr
                key={row.data.find((item: any) => item.name === "lineId").value}
                className={`table-tr ${this.returnTrErrorClass(row)}`}
                id={`table-tr-${rowIndex}`}
                data-highlight-id={`file-${row.data.find((item: any) => item.name === "fileId").value}`}
              >
                {columns.map((column: any, columnIndex: any) => {
                  if (!column.isShow) {
                    return;
                  }
                  const rowColumn = row.data.find((x: any) => x.name === column.dataName);
                  if (column.type === "checkbox") {
                    // @ts-ignore
                    return this.returnCheckBox(column, row);
                  } else {
                    return (
                      // @ts-ignore
                      <td
                        key={column.dataName}
                        style={{
                          display: this.columnShowStyle(column),
                        }}
                        className={`${typeToClassName[column.type] || typeToClassName.default} ${column.dataName + "Td"}`}
                      >
                        {/* @ts-ignore */}
                        {column.type === "link" &&
                          this.returnLink(rowColumn, column, rowIndex, row)}
                        {column.type === "fileName" && this.returnFileName(rowColumn, column, row)}
                        {/* @ts-ignore */}
                        {column.type === "input" &&
                          this.returnInput(
                            row,
                            rowColumn,
                            column,
                            rowIndex,
                            isShowReturnReason,
                            procedureNoteMaxLength,
                            fileSectionDisabled
                          )}
                        {/* @ts-ignore */}
                        {column.type === "select" &&
                          this.returnSelect(
                            currentRole,
                            rowColumn,
                            column,
                            row,
                            rowIndex,
                            optionList
                          )}
                        {column.type === "button" && this.returnButton(row, column, rowIndex, true)}
                        {column.type === "tag" && this.returnTag(rowColumn)}
                        {this.judgeIsShowText(column) && rowColumn.value}
                      </td>
                    );
                  }
                })}
              </tr>
            );
          })}
        </tbody>
      </>
    );
  }
}
